import { render, staticRenderFns } from "./IdentityCardPrinting.vue?vue&type=template&id=2805ec8c&scoped=true"
import script from "./IdentityCardPrinting.vue?vue&type=script&lang=js"
export * from "./IdentityCardPrinting.vue?vue&type=script&lang=js"
import style0 from "./IdentityCardPrinting.vue?vue&type=style&index=0&id=2805ec8c&prod&scoped=true&lang=css"
import style1 from "./IdentityCardPrinting.vue?vue&type=style&index=1&id=2805ec8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805ec8c",
  null
  
)

export default component.exports